import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { CorrelativoTancadasApi } from "../api/CorrelativoTancadasApi";
import { getErrorFromResponse } from "../../../../../utility/utils";

// Estado del correlativo de tancadas: lo usa el bloque que lo configura y lo
// reinicia, y también las pantallas que quedan bloqueadas mientras no exista
export const useCorrelativoTancadas = () => {
    const {
        getEstadoCorrelativo,
        abrirPeriodo,
        deshacerPeriodo,
        cargando,
    } = CorrelativoTancadasApi();

    const [estado, setEstado] = useState(null);

    const CargarEstado = async () => {
        try {
            const response = await getEstadoCorrelativo();
            setEstado(response);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el correlativo de tancadas",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        CargarEstado();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const AbrirPeriodo = async (correlativoInicial, mensajeExito) => {
        try {
            const response = await abrirPeriodo({
                correlativo_inicial: correlativoInicial,
            });

            setEstado(response);

            NotificationManager.success(mensajeExito, "Éxito", 3000);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al abrir el período del correlativo",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const ConfigurarCorrelativo = async (correlativoInicial) => {
        await AbrirPeriodo(correlativoInicial, "Correlativo configurado");
    };

    const ReiniciarCorrelativo = async () => {
        await AbrirPeriodo(null, "Correlativo reiniciado");
    };

    const DeshacerPeriodo = async () => {
        try {
            const response = await deshacerPeriodo();

            setEstado(response);

            NotificationManager.success("Período deshecho", "Éxito", 3000);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al deshacer el período",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    // mientras responde el servidor se asume configurado, para no mostrar el
    // bloqueo en un parpadeo
    const configurado = estado ? estado.configurado : true;
    const periodo = estado ? estado.periodo : null;
    const totalPeriodos = estado ? estado.total_periodos : 0;
    const tancadasNumeradas = estado ? estado.tancadas_numeradas : 0;
    const siguienteNumero = estado ? estado.siguiente_numero : "";
    const periodoAbiertoEsteMes = estado
        ? estado.periodo_abierto_este_mes
        : false;
    const puedeDeshacer = estado ? estado.puede_deshacer : false;

    return {
        estado,
        configurado,
        periodo,
        totalPeriodos,
        tancadasNumeradas,
        siguienteNumero,
        periodoAbiertoEsteMes,
        puedeDeshacer,

        CargarEstado,
        ConfigurarCorrelativo,
        ReiniciarCorrelativo,
        DeshacerPeriodo,
        cargando,
    };
};
